import { render } from "./ReqsView.vue?vue&type=template&id=2818c9f4"
import script from "./ReqsView.vue?vue&type=script&lang=js"
export * from "./ReqsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__